module.exports = __webpack_public_path__ + "media/assets/images/dairitengata-img-b9eaf23e3efd3afbffebe35f897b6e23.png";